import React from 'react'
import PropTypes from 'prop-types'
import MuiSwitch from '@material-ui/core/Switch'

class Switch extends React.PureComponent {

  handleChange = (e) => {
    this.props.onChange(e.target.checked)
  }
  render () {
    const { onChange, ...otherProps } = this.props

    return <MuiSwitch onChange={this.handleChange} {...otherProps} />
  }
}

Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  color: PropTypes.oneOf(['primary', 'secondary', 'default'])
}
Switch.defaultProps = {
  color: 'primary'
}
export default Switch
